// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { platformAdminIdentityUserMemberships } from "./platform-admin-identity-user-memberships";

export const platformAdminIdentityUserWorkflows = {
  actions: {
    assignPlatformRole: "Platform Role Assignment",
    createUser: "Create Platform User",
    editUser: "Edit Platform User",
  },
  drawers: {
    authorization: "Authorization · {name}",
    authorizationShort: "Authorization",
    userEdit: "Edit Platform User · {name}",
    userEditShort: "Edit Platform User",
    ...platformAdminIdentityUserMemberships.drawers,
  },
  alerts: {
    userCreatePolicy:
      "Platform users must change the initial password on first login. If Expires At is set, login and session refresh will be blocked after expiry.",
    userCreateApplicationRoles:
      "Optional: after the platform user is created, the form will create each user-level application-role mapping in sequence. If any mapping fails, the result is reported as partial success.",
    userCreateOidcApplicationRoles:
      "Optional: after user creation, the form creates user-level mappings under OIDC Application Role Authorization. This drawer currently supports only airange-admin catalogs.",
    userEditApplicationRoles:
      "Saving edits first updates the user's basic profile and platform roles, then applies a diff to user-level application-role mappings. Platform-role mappings and base-role mappings are not modified here.",
    ...platformAdminIdentityUserMemberships.alerts,
  },
  confirms: {
    resetPasswordTitle: "Reset Platform User Password",
    resetPasswordDescription:
      "Reset the password for {username}? The temporary password is shown only in this response.",
    kickoutTitle: "Kick Out Platform User",
    kickoutDescription:
      "Invalidate this user's current sessions immediately? The user will need to sign in again.",
    batchDisableDescription: "Set {count} users to {status}",
    impersonateTitle: "Impersonate Platform User",
    impersonateDescription:
      "Enter the current platform workspace as {username}? This only applies to the current platform frontend and can be exited at any time.",
    updateUserStatusTitle: "Update Platform User Status",
    updateUserStatusDescription: "Update {username} to {status}?",
    ...platformAdminIdentityUserMemberships.confirms,
  },
  messages: {
    userCreated: "Platform user created",
    userCreatedWithRoleMappings:
      "Platform user created and {count} application role mappings were created",
    userCreatedWithPartialRoleMappings:
      "Platform user created, but {failedCount} application role mappings failed: {details}",
    userUpdated: "Platform user updated",
    userUpdatedWithPartialRoleMappings:
      "Platform user updated, but {failedCount} application role mapping updates failed: {details}",
    userMappingApplicationUnavailable: "Application unavailable: {application} / {role}",
    userMappingCreateFailedForApp: "Application role mapping failed: {application} / {role}",
    userMappingDeleteFailedForApp:
      "Failed to remove application role mapping: {application} / {role}",
    userCreateFailed: "Failed to create platform user",
    userUpdateFailed: "Failed to update platform user",
    userStatusUpdated: "Platform user status updated",
    userStatusUpdateFailed: "Failed to update platform user status",
    passwordReset: "Platform user password reset",
    passwordResetFailed: "Failed to reset platform user password",
    kickoutSuccess: "Platform user kicked out",
    kickoutFailed: "Failed to kick out platform user",
    batchKickoutSuccess: "Kicked out {count} users",
    batchKickoutAlreadyOffline: "{count} users were already offline",
    batchDisableSuccess: "Disabled {count} users",
    batchDisableAlreadyInactive: "{count} users were already inactive",
    batchSkippedCurrentUser: "Skipped {count} current users",
    batchUsersNotFound: "{count} users were not found",
    impersonateFailed: "Failed to impersonate platform user",
    impersonateSelfDisabled: "Cannot impersonate yourself",
    impersonateInactiveDisabled: "User is inactive and cannot be impersonated",
    impersonationBanner:
      "You are currently operating as {target} ({targetUsername}); original administrator: {actor} ({actorUsername}).",
    temporaryPasswordVisibleOnce:
      "The temporary password is shown only once. Copy it now and send it to the user. The user must change it on next login.",
    noTargetUser: "No target user selected",
    usersPartialLoadFailed: "Failed to load the user list, but other identity data has been kept",
    ...platformAdminIdentityUserMemberships.messages,
  },
  forms: {
    userCreate: "Create Platform User",
    userEdit: "Edit Platform User",
    userEditShort: "Edit Platform User",
    username: "Username",
    nickname: "Nickname",
    nicknamePlaceholder: "Optional; defaults to username",
    phone: "Mobile Phone",
    initialPassword: "Initial Password",
    expiresAt: "Expires At",
    expiresAtPlaceholder: "Optional; leave empty for a long-lived account",
    applicationRoleMappings: "Application Role Mappings",
    addApplicationRoleMapping: "Add Application Role Mapping",
    applicationRoleMappingItem: "Mapping #{index}",
    applicationAdminRole: "Administrator (admin)",
    applicationPlatformAdminRole: "Platform Administrator (platform_admin)",
    oidcApplicationRoleMappings: "User-Level OIDC Application Role Authorization",
    addOidcApplicationRoleMapping: "Add OIDC Application Role Authorization",
    oidcApplicationRoleMappingItem: "OIDC Mapping #{index}",
    targetUser: "Target User",
    oidcApplicationOwner: "OIDC Application",
    platformRoleAuthorization: "Platform Role Authorization",
    userLevelOidcApplicationRoleMappingsHint:
      "This area manages user-level OIDC application role authorization only. Access granted automatically through platform roles or application grants is not shown here. For airange-admin, many permissions are mapped automatically from platform roles, so duplicate manual authorization is usually unnecessary.",
    duplicateAirangeAdminUserLevelAuthorizationHint:
      "The user already has platform roles that map automatically into airange-admin: {roles}. Granting the same user-level role to airange-admin below is usually redundant.",
    requiredUsername: "Please enter username",
    requiredInitialPassword: "Please enter initial password",
    requiredPlatformRoles: "Please select at least one platform role",
    requiredUserSubject: "Please select user",
    selectUserSubject: "Select User",
    userSubjectEmpty: "No user selected",
    userSubjectPickerTitle: "Select Role Mapping User Subject",
    userSubjectPickerEmpty: "No identity users available",
    requiredTargetOidcBusinessRole: "Please select target OIDC business role",
    requiredOidcApplicationOwner: "Please select OIDC application",
    targetOidcBusinessRole: "Target OIDC Business Role",
    ...platformAdminIdentityUserMemberships.forms,
  },
} as const;
